import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import StatusContainer from "../../_utils/CommonStatus/StatusContainer";
import InfoCard from "../../_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import FormatAmount from "../../_utils/FormatAmount/FormatAmount";
import ICONS from "../../../assets/Icons";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import accountNameStandardised from "../../../utils/accountNamestandardised";
import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { useDispatch } from "react-redux";
import CommonToast from "../../_utils/CommonToast";

const FieldForceTransactionMultiApprovalSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [successPageData, setsuccessPageData] = useState([]);
  const [successPageID, setsuccessPageID] = useState([]);
  const [pendingTransactions, setPendingTransactions] = useState([]);
  const [approvedTransactions, setApprovedTransactions] = useState([]);

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedFieldForceTxnData"),
    );

    if (storedSelectedApproval) {
      const transactions =
        storedSelectedApproval?.selectedSendTransactions || [];
      const transactionIds = storedSelectedApproval?.selectedTransactions || [];

      const pending = transactions.filter(
        (transaction) => transaction.lifecycle_status === "pending",
      );

      const approved = transactions.filter(
        (transaction) =>
          transaction.lifecycle_status === "approved" ||
          transaction.lifecycle_status === "success" ||
          !transaction.lifecycle_status,
      );

      setsuccessPageData(transactions);
      setPendingTransactions(pending);
      setApprovedTransactions(approved);
      setsuccessPageID(transactionIds);
    } else {
      setsuccessPageData([]);
      setsuccessPageID([]);
      setPendingTransactions([]);
      setApprovedTransactions([]);
    }
  }, []);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const goToDashboard = () => {
    navigate("/field_force_transaction_dashboard");
  };

  const approveMoreTransactions = () => {
    navigate(
      "/field_force_transaction_dashboard/field_force_transaction_multi_approval",
    );
  };

  const buttonRows = [
    [
      {
        btnText: "Go to approval",
        icon: ICONS?.GO_TO_APPROVAL_WHITE_CIRCLE,
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        imgColor: "var(--positive-bg)",
        handleFunction: approveMoreTransactions,
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: goToDashboard,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  return (
    <>
      <StatusContainer
        status="success"
        title={
          successPageData.length
            ? "Transactions approved successfully."
            : "Processing transactions..."
        }
        buttonRows={buttonRows}
      >
        {/* SECTION 1: Render All Successfully Processed Distributions */}
        {approvedTransactions.length > GlobalConfiguration.lengthCheckZero && (
          <TabsWeapperSection
            title={`Distribution created - ${approvedTransactions.length}`}
          >
            <div className="flex flex-col">
              {approvedTransactions.map((account, i) => (
                <InfoCard
                  key={`approved-${account?.txn_id || i}`}
                  bgColor="var(--positive-card)"
                  hoverable="white"
                  onClick={() => {
                    navigate(
                      `/field_force_transaction_dashboard/field_force_transaction_view_all/field_force_transaction_detail_page/${account?.txn_id || i}`,
                    );
                  }}
                  rows={[
                    {
                      leftTitle: accountNameStandardised(
                        account?.field_force_account_name,
                      ),
                      leftSubTitle: "Account name",
                      rightTitleTextColor: "var(--text-primary)",
                      rightTextFontWeight: "semibold",
                      hasRight: true,
                      rightIcon: true,
                      rightText: true,
                      rightTitle: `INR ${FormatAmount({ price: account?.amount || 0 })}`,
                      rightSubTitle: "Amount",
                    },
                  ]}
                />
              ))}
            </div>
          </TabsWeapperSection>
        )}

        {/* SECTION 2: Render Items Remaining In Pending Queue */}
        {pendingTransactions.length > GlobalConfiguration.lengthCheckZero && (
          <TabsWeapperSection title={`Pending - ${pendingTransactions.length}`}>
            <div className="flex flex-col">
              {pendingTransactions.map((account, i) => (
                <InfoCard
                  key={`pending-${account?.txn_id || i}`}
                  bgColor="var(--positive-card)"
                  hoverable="white"
                  onClick={() => {
                    navigate(
                      `/field_force_transaction_dashboard/field_force_transaction_view_all/field_force_transaction_detail_page/${account?.txn_id || i}`,
                    );
                  }}
                  rows={[
                    {
                      leftTitle: accountNameStandardised(
                        account?.field_force_account_name,
                      ),
                      leftSubTitle: "Account name",
                      rightTitleTextColor: "var(--text-primary)",
                      rightTextFontWeight: "semibold",
                      hasRight: true,
                      rightIcon: true,
                      rightText: true,
                      rightTitle: `INR ${FormatAmount({ price: account?.amount || 0 })}`,
                      rightSubTitle: "Amount",
                      onClick: () => {
                        navigate(
                          `/field_force_transaction_dashboard/field_force_transaction_view_all/field_force_transaction_detail_page/${account?.txn_id || i}`,
                        );
                      },
                    },
                  ]}
                />
              ))}
            </div>
          </TabsWeapperSection>
        )}
      </StatusContainer>
    </>
  );
};

export default FieldForceTransactionMultiApprovalSuccess;
